import { useEffect, useState } from 'react';

type ImmersiveOverlayState = {
  isOpen: boolean;
  listing: unknown | null;
  index: number;
  total: number;
};

let state: ImmersiveOverlayState = { isOpen: false, listing: null, index: 0, total: 0 };
const listeners = new Set<() => void>();

const emitChange = () => {
  listeners.forEach((listener) => listener());
};

export const openOverlay = (listing: unknown, index: number = 0, total: number = 0) => {
  state = { isOpen: true, listing, index, total };
  emitChange();
};

export const closeOverlay = () => {
  state = { isOpen: false, listing: null, index: 0, total: 0 };
  emitChange();
};

export const setIndex = (index: number) => {
  state = { ...state, index };
  emitChange();
};

export const getSnapshot = (): ImmersiveOverlayState => state;

export const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

// Uses useState + useEffect instead of useSyncExternalStore to avoid
// SSR crash (react-ssr-prepass doesn't support useSyncExternalStore).
// Safe here because overlay state changes are user-driven click events.
export const useImmersiveOverlay = () => {
  const [current, setCurrent] = useState(getSnapshot);

  useEffect(() => {
    setCurrent(getSnapshot());
    return subscribe(() => setCurrent(getSnapshot()));
  }, []);

  return current;
};
